import axios from 'axios';
function getAll(query = null) {
    return axios.get('ticketstab', {
        params: query
    });
}

function countTicketMe(query = null) {
    return axios.get('ticketstab/count',{
        params: query
    });
}

function countTicketEsp(query = null) {
    return axios.get('ticketstab/countesp',{
        params: query
    });
}

function countTicketTic(query = null) {
    return axios.get('ticketstab/counttic',{
        params: query
    });
}

function operatividadCam(query = null) {
    return axios.get('ticketstab/operativ',{
        params: query
    });
}

function tablaTickets(query = null) {
    return axios.get('ticketstab/tickets',{
        params: query
    });
}

function dashboardMetricas(query = null) {
    return axios.get('ticketstab/dashboard',{
        params: query
    });
}

function dashboardMetricasExcel(query = null) {
    return axios.get('ticketstab/dashboard/excel',{
        responseType: 'blob',
        params: query
    });
}

const TablaTicketService = {
    getAll,
    countTicketMe,
    countTicketEsp,
    countTicketTic,
    operatividadCam,
    tablaTickets,
    dashboardMetricas,
    dashboardMetricasExcel
};
export default TablaTicketService;